<template>
  <div>

  </div>
</template>

<script>
  export default {
    name:'templete',

  }
</script>

<style type="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/templete.vue